<div class="filter-toolbar" style="display: flex; flex-direction: column; align-items: stretch; padding: 4px;">
	<div class="btn-group btn-group-sm" role="group">
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'all' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('all')"
			title="Alle Punkte anzeigen">
			Alle
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'map' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('map')"
			title="Nur Punkte im Kartenausschnitt">
			Karte
		</button>
		<button type="button" class="btn"
			[ngClass]="listFilterMode === 'selection' ? 'btn-primary' : 'btn-outline-secondary'"
			(click)="setListFilterMode('selection')"
			title="Nur ausgewählte Punkte">
			Auswahl
		</button>
	</div>
	<div class="input-group input-group-sm mt-1">
		<input type="text" class="form-control" placeholder="Nr, Amt, Revier..."
			[(ngModel)]="searchText" (ngModelChange)="onSearchTextChange($event)"
			title="Sucht in: Nummer, Forstamt, Revier, Kartierer">
		<button *ngIf="searchText" class="btn btn-outline-secondary" type="button" (click)="clearSearch()" title="Suche löschen">x</button>
	</div>
	<div ngbDropdown class="mt-1">
		<button type="button" class="btn btn-sm w-100" ngbDropdownToggle
			[ngClass]="currentFilterName ? 'btn-info' : 'btn-outline-secondary'">
			{{ currentFilterName || 'Filter' }}
		</button>
		<div ngbDropdownMenu class="w-100">
			<button ngbDropdownItem (click)="clearFilter()">
				<em>Kein Filter</em>
			</button>
			<div class="dropdown-divider" *ngIf="filterNames.length > 0"></div>
			<button ngbDropdownItem *ngFor="let name of filterNames" (click)="applyQuickFilter(name)"
				[class.active]="currentFilterName === name">
				{{ name }}
			</button>
		</div>
	</div>
	<!-- Auswahl-Aktionen: alle Buttons nebeneinander -->
	<div class="btn-group btn-group-sm mt-1 w-100" role="group">
		<button type="button" class="btn btn-outline-success"
			[disabled]="getVisibleCount() === 0"
			(click)="addVisibleToSelection()"
			title="Alle sichtbaren Punkte zur Auswahl hinzufügen">
			<bi name="plus-lg"></bi>
		</button>
		<button type="button" class="btn btn-outline-danger"
			[disabled]="getVisibleSelectedCount() === 0"
			(click)="removeVisibleFromSelection()"
			title="Sichtbare aus Auswahl entfernen">
			<bi name="dash-lg"></bi>
		</button>
		<button type="button" class="btn btn-outline-secondary"
			[disabled]="selectionService.count() === 0"
			(click)="clearSelection()"
			title="Auswahl aufheben">
			<bi name="x-circle"></bi>
		</button>
		<button type="button" class="btn btn-outline-info"
			[disabled]="selectionService.count() === 0"
			(click)="printSelection()"
			title="Ausgewählte drucken">
			<bi name="printer"></bi>
		</button>
		<button type="button" class="btn btn-outline-danger"
			[disabled]="selectionService.count() === 0 || !ps.canIremove()"
			(click)="deleteSelection()"
			title="Ausgewählte löschen">
			<bi name="trash"></bi>
		</button>
	</div>
	<div class="text-muted small text-center mt-1">{{ getVisibleCount() }} / {{ bps.length }}</div>
</div>
<table class="table table-hover">
	<thead>
		<tr>
			<th *ngIf="aus.canI('read', 'points')"></th>
			<th>Nummer</th>
			<th>Forstbetrieb</th>
			<th>Revier</th>
			<th>Aufnahmedatum</th>
			<th>Adresse</th>
		</tr>
	</thead>
	<tbody>
		<tr [ngClass]="{'filter': this.bpFilter[i]}" *ngFor="let bp of bps; let i=index" [hidden]="!isVisible(i)">
			<td *ngIf="aus.canI('read', 'points')"><button class="btn btn-sm btn-outline-info" [routerLink]="[bp._id]"><span class="badge"><bi name="geo"></bi></span></button></td>
			<td><bp-bohrpunkt-nummer [label]="punktLabel(bp)" [state]="bp.state"></bp-bohrpunkt-nummer></td>
			<td>{{bp.header.forstamt}}</td>
			<td>{{bp.header.revier}}</td>
			<td>{{dateString(bp.header.aufnahme.datum) | maskForGuest}}</td>
			<td>{{bp.header.adresse.abteilung}}{{bp.header.adresse.unterabteilung}}{{bp.header.adresse.teilflaeche}}</td>
		</tr>
	</tbody>
</table>
